import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-6" }, "结算暂停管理", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "当前状态", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-gray-500" }, "查询中...", -1)
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center gap-4 mb-4"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("结算暂停中")
const _hoisted_8 = { class: "text-gray-600" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 剩余约 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 自动解除 ")
const _hoisted_11 = {
  key: 1,
  class: "d-flex align-items-center gap-4 mb-4"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("正常开放")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "当前未处于结算暂停状态", -1)
const _hoisted_14 = { class: "d-flex gap-3" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("立即解除暂停")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("刷新状态")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_card, {
      class: "mb-4",
      style: {"max-width":"520px"}
    }, {
      header: _withCtx(() => [
        _hoisted_3
      ]),
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_icon, { class: "is-loading" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Loading)
                ]),
                _: 1
              }),
              _hoisted_5
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.paused)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_el_tag, {
                      type: "danger",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.ttlDisplay), 1),
                      _hoisted_10
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_el_tag, {
                      type: "success",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }),
                    _hoisted_13
                  ])),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.paused)
                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                      key: 0,
                      title: "确认手动解除结算暂停？解除后玩家可立即抽赏。",
                      "confirm-button-text": "确认解除",
                      "cancel-button-text": "取消",
                      "confirm-button-type": "danger",
                      onConfirm: _ctx.liftPause
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          loading: _ctx.lifting
                        }, {
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    }, 8, ["onConfirm"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  loading: _ctx.loading,
                  onClick: _ctx.fetchStatus
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ])
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_el_alert, {
      title: "说明",
      type: "info",
      closable: false,
      description: "每天 23:00 系统自动进入结算暂停，发放流水排行奖励后保持暂停直到 00:00 自动解除。如需提前开放，点击「立即解除暂停」。"
    })
  ]))
}